import { createRouter, createWebHashHistory, RouteRecordRaw } from 'vue-router'
import home from '../views/home/index.vue'
import login from '../views/login/index.vue'
import user from '../views/user/index.vue'
import edit from '../views/edit/index.vue'

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    redirect: "/home",
  },
  {
    path: '/home',
    name: 'home',
    component: home
  },
  {
    path: '/login',
    name: 'login',
    component: login
  },
  {
    path: '/user',
    name: 'user',
    component: user
  },
  {
    path: '/user/edit/:id',
    name: 'edit',
    component: edit
  }
]

const router = createRouter({
  history: createWebHashHistory(), 
  routes
})

// Route guard to check for token
// router.beforeEach((to, from, next) => {
//   const token = localStorage.getItem('token'); // Assuming token is stored in localStorage
//   if (!token && to.name !== 'login') {
//     next({ name: 'login' }); // Redirect to login if no token and not already on login page
//   } else {
//     next(); // Proceed to the route
//   }
// });

export default router 
